import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'reportKey',
    label: 'Report Key',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
